module.exports = __webpack_public_path__ + "img/mail.25c6894f.svg";